<template>
  <UIInputAutocomplete v-model="actionValue" :size :data :disabled />
</template>

<script setup lang="ts">
import { computed, inject, onBeforeMount } from 'vue'
import { orderBy } from 'lodash'

import { InputSize } from '@types'
import { TaggingRuleAction } from '../utils/types'

import { ASSET_FIELD } from '@/entities/assets/utils/const'

import { useAssetsBunchStore } from '@/store/assets/bunch'

import { UIInputAutocomplete } from '@ui/fields'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<TaggingRuleAction>({
  required: true,
})

const assetsBunchStore = useAssetsBunchStore()

const size = inject<InputSize>('size')

const accountsInstancesList = computed(() =>
  Array.from(assetsBunchStore.getCommonList.values()),
)

const data = computed(() => {
  return orderBy(
    accountsInstancesList.value.map(item => ({
      value: item.id,
      label: item.field<string>(ASSET_FIELD.NAME).value,
    })),
    'label',
  )
})

const actionValue = computed({
  get() {
    return modelValue.value.value
  },
  set(value) {
    modelValue.value = {
      ...modelValue.value,
      value: value || '',
    }
  },
})

onBeforeMount(() => {
  if (actionValue.value !== undefined) return
  actionValue.value = ''
})
</script>
